import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const updateSubCategory = createAsyncThunk('updateSubCategory', async (data) => {

    var bodyFormData = new FormData();

    bodyFormData.append("main_category_id", data?.values?.category);
    bodyFormData.append("id", data?.values?.id);
    bodyFormData.append("name", data?.values?.name);
    bodyFormData.append("description", data?.values?.description);
    bodyFormData.append("status", data?.values?.status);

    if (data?.values?.image) {
        bodyFormData.append("image", data?.values?.image);
    }

    try {
        const res = await axios({

            method: 'PUT',
            url: process.env.REACT_APP_API_URL + 'category',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

